export const DEBUG_LOCAL = false;
export const RECEIPT_IMAGE_MAX_SIZE = 1440;
export const ITEM_IMAGE_MAX_SIZE = 640;
export const ITEM_IMAGE_THUMBNAIL_MAX_SIZE = 320;
export const COMPANY_LOGO_IMAGE_MAX_SIZE = 640;
export const COMPANY_LOGO_IMAGE_THUMBNAIL_MAX_SIZE = 320;
export const IMAGE_COMPRESS_QUALITY = 0.6;